import Vue from 'vue';
import store from './store';
import router from './router';
import ajax from '@/services/base.service.js';

import './mixins';
import './thirdparty';
import './scss/core.scss';

import AppLayout from './layout/Index.vue';

Vue.config.productionTip = false;

const API = {
    install(Vue, options) {
        Vue.prototype.$AJAX = ajax;
    }
};
Vue.use(API);

(() => new Vue({
    name: 'Root',
    template: '<AppLayout />',
    components: { AppLayout },
    el: '#app',
    router,
    store,
    mounted() {
        //-- Check at each routes that the user is still connected
        router.afterEach((to, from) => {
            //console.log(from);
            //console.log("=>");
            //console.log(to.meta.auth);

            if (to.meta.auth)
                this.$checkAuth();
        });

        //-- Clearing array izi
        Array.prototype.clear = function() {
            while (this.length > 0) {
                this.pop();
            } // Fastest
        };

        //-- Used to compare date in an array (find doesn't work)
        Array.prototype.indexOfDate = function (date) {
            for (var i = 0; i < this.length; i++) {
                if (+this[i] === +date) return i;
            };
            return -1;
        };
        

    }
}))();



// WEBPACK FOOTER //
// ./src/app.init.js